import { Flex } from "@chakra-ui/layout";
import { Icon } from "@src/components/ui-kit/Icon";
import type React from "react";
import type { FunctionComponent, ReactNode } from "react";

export const CardIcon = () => (
  <Flex
    w="10"
    h="10"
    borderRadius="50%"
    align="center"
    justify="center"
    bg="teal.500"
  >
    <Icon name="wallet-02" color="white" />
  </Flex>
);

export const CardHeader: FunctionComponent<
  React.PropsWithChildren<{
    title: string;
    additionalInfo: ReactNode;
    button: ReactNode;
    icon: ReactNode;
  }>
> = ({ title, additionalInfo, icon, button }) => (
  <div className="flex items-center py-2">
    <div className="flex items-center flex-1">
      <span className="mr-5">{icon}</span>
      <div>
        <h2 className="text-2xl font-bold mb-1">{title}</h2>
        <span>{additionalInfo}</span>
      </div>
    </div>
    <div className="flex items-center">{button}</div>
  </div>
);
